import { AttachFile } from '@material-ui/icons';

import Separator from '../ui/Separator';

const AttachedFiles = ({ attachedFiles }) => (
  <div className="c-attached-files">
    <Separator color="brown">{`Archivos adjuntos (${attachedFiles.length})`}</Separator>
    <div className="c-attached-files__container">
      {attachedFiles.map((attached) => (
        <div className="c-attached-files__file-container">
          <AttachFile />
          <a target="_blank" href={attached.url} rel="noreferrer">
            {attached.name}
          </a>
        </div>
      ))}
    </div>
  </div>
);

export default AttachedFiles;
